type SecondaryCriteriaElementType =
  | "projectElement"
  | "project"
  | "resource"
  | "projectReport"
  | "timeRecord";

export type { SecondaryCriteriaElementType };
